// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import '@/assets/iconfont/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/theme/index.css'
import router from './router'
import validates from '@/assets/script/validationRule.js' //全局验证
import VirtualCollection from 'vue-virtual-collection'
import Moment from 'moment'
import Echarts from 'echarts'
import 'echarts/map/js/china'
import store from '@/views/store/index'

// import Vant from 'vant';



import VueCropper from 'vue-cropper' 
import 'babel-polyfill'
// import 'vant/lib/index.css';
import '@/assets/style/common.css'

Vue.use(VueCropper)
Vue.use(ElementUI);
// Vue.use(Vant);
Vue.use(validates)//验证js
Vue.use(VirtualCollection)

Vue.config.productionTip = false
// 引入 axios 文件
import api from '@/assets/axios_api/index.js'
// 绑定 axios 到全局（vue对象原型方法）
Vue.prototype.$api = api
Vue.prototype.echarts = Echarts 
Vue.use(Echarts)

// 引入二次确认弹窗
import confirms from './assets/script/confirm.js'
Vue.prototype.$confirms=confirms
//提示框
import tip from './assets/script/tip.js'
Vue.prototype.$tip=tip
//全局方法
import common from './assets/script/common.js'
Vue.prototype.$common = common

// 引入 导出下载 文件
import Files from './assets/axios_api/exportFile.js'
// 绑定 导出下载 到全局（vue对象原型方法）
Vue.prototype.$File=Files

Vue.prototype.moment = Moment
//md5加密
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
//rsa 加密
import JSEncrypt from 'jsencrypt';
Vue.prototype.$getRsaCode = function(pubKey,str){ // 注册方法
  let encryptStr = new JSEncrypt();
  encryptStr.setPublicKey(pubKey); // 设置 加密公钥
  let data = encryptStr.encrypt(str);  // 进行加密
  return data;
}
//接口路径配置
import globalPath from '@/assets/script/globalPath.vue' 
Vue.prototype.API = globalPath.globalPath //接口路径配置

import VueResource from 'vue-resource' //使用的json数据
Vue.use(VueResource)

import * as filters from '@/assets/script/filters.js'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
/* eslint-disable no-new */
window.Vue =new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js